// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../../../utils/colors.css\"","green":"#006761","red":"#A93E2F","valid":"AccountDataForm_valid__18Jn-","invalid":"AccountDataForm_invalid__3K_Ip"};